// Converte a query string do /auto-login no corpo de POST companies/auto-login.
// Só o token de uso único gerado pelo OS Digital vale (TASK-23690): o link
// antigo, com a senha da oficina na URL, não é mais aceito pela API.
// Retorna null quando o link não traz o token.
export function buildAutoLoginPayload(search) {
  const token = new URLSearchParams(search).get('token');
  return token ? { token } : null;
}
